import React, { useState } from "react";
import "../styles/ContactUs.styles.css";

function ContactUs() {
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage("");
        setErrorMessage("");

        try {
            const response = await fetch("http://localhost/PHPMailer-master/sendMail.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.success) {
                setSuccessMessage(result.message || "تم إرسال الرسالة بنجاح!");
                setFormData({ name: "", email: "", message: "" }); // تفريغ الحقول بعد الإرسال
            } else {
                throw new Error(result.message || "حدث خطأ أثناء إرسال الرسالة.");
            }
        } catch (error) {
            setErrorMessage(error.message || "حدث خطأ أثناء إرسال الرسالة.");
        }
    };

    return (
        <section id="contact" className="py-5">
            <div className="container">
                <h2 className="text-center">اتصل بنا</h2>
                <div className="row">
                <div className="col-md-6">
                <h4>معلومات التواصل</h4>
                <p>
                    <i className="bi bi-phone icon"></i>
                    رقم الموبايل:
                    <a href="tel:00963944576567" className="ms-2"> 944576567 00963</a>
                </p>
                <p>
                    <i className="bi bi-whatsapp icon"></i>
                    واتساب:
                    <a href="https://wa.me/00963944576567" target="_blank" rel="noopener noreferrer" className="ms-2"> 944576567 00963</a>
                </p>
                <p>
                    <i className="bi bi-telephone icon"></i>
                    رقم الهاتف الأرضي:
                    <span className="ms-2"> 2224940 033</span>
                </p>
                <p>
                    <i className="bi bi-geo-alt icon"></i>
                    العنوان:
                    <span className="ms-2">سوريا، حماة، نهاية طلعة باب البلد</span>
                </p>
            </div>
            
                    <div className="col-md-6">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label className ="labels">الاسم</label>
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    placeholder="أدخل اسمك"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label className ="labels">البريد الإلكتروني</label>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control"
                                    placeholder="أدخل بريدك الإلكتروني"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label className ="labels">رسالتك</label>
                                <textarea
                                    name="message"
                                    className="form-control"
                                    rows="4"
                                    placeholder="أدخل رسالتك"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>
                            <button type="submit" className="btn btn-primary button">أرسل الرسالة</button>
                        </form>
                        {successMessage && <p className="text-success">{successMessage}</p>}
                        {errorMessage && <p className="text-danger">{errorMessage}</p>}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactUs;
